import {
  tApi
} from 'tplus-api';
/**
 * 获取促销方案的API
 */
export default class PromotionApi {
  static async getSalesPromotionList(dto) {
    return await tApi({
      parameterDTO: dto
    }, 'chanjet.PR.INewSalesPromotion.GetSalesPromotionList');
  }

  static async GetInventoryInfo(ids) {
    return await tApi({
      Param: JSON.stringify({
        "InventoryIDlist": ids.map(it => it.toString()),
        "PageIndex": 1,
        "PageSize": ids.length,
      })
    }, 'chanjet.AA.MB.MBAAInventory.GetInventoryInfo');
  }

  static async GetBatchDispatchAndAllocateQuantity(param) {
    return await tApi(param, 'chanjet.ST.MBStockReport.GetBatchDispatchAndAllocateQuantity');
  }

  static async GetInvFreeItemsDetails(ID) {
    const method = 'chanjet.AA.MB.MBAAInventory.GetInvFreeItemsDetails';
    ID = ID.toString();
    var param = {
      ID
    };
    const resp = await tApi(param, method, true);
    return resp;
  }

  static async GetInventoryPromotionPrice(param) {
    const method = 'chanjet.SA.MBSale.GetInventoryPromotionPrice';
    const resp = await tApi(param, method, true);
    return resp;
  }
}
